export default __webpack_public_path__ + "static/3-afe10b898cfcd539a937a895e573eade.jpg";